import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';
import classNames from "classnames"
import Wrapper from "./form"
import Input from "./input"

class Enquiry extends Component {
	constructor(props) {
        super(props);
        this.state = {
            items: localStorage.getItem("enquiry-product"),
            isEmpty: !localStorage.getItem("enquiry-product"),
        };
    }
    
    componentDidMount() {
        window.addEventListener("on-storage", this.handleStorageChange, false);
    }
    componentWillUnmount() {
        window.removeEventListener("on-storage", this.handleStorageChange);
    }
    
    handleStorageChange = () => {
        this.setState({
            items: localStorage.getItem("enquiry-product"),
            isEmpty: !localStorage.getItem("enquiry-product"),
        });
    };
    

	componentClassName = () => classNames("product-enquiry", {
		"is-empty": this.state.isEmpty,
	})

	productCodes = (items) => {
		const codes = []

		JSON.parse(items).forEach((item) => {
			const data = `${item.code} (${item.count})`
			codes.push(data)
		})

		return codes.join(", ")
	}

	removeProduct = (id) => {
		const storage = []

		JSON.parse(this.state.items).forEach((item) => {
			if (item.id !== id) {
				storage.push(item)
			}
		})

		if (storage.length) {
			localStorage.setItem("enquiry-product", JSON.stringify(storage))
		} else {
			localStorage.removeItem("enquiry-product")
		}

		window.dispatchEvent(new Event("on-storage"))
	}

	render() {
		return (
            <div className={this.componentClassName()}>
                { this.state.items ? (
                    <div>
                        <div className="product-enquiry__container">
                            <ul className="product-enquiry__list">
                                { JSON.parse(this.state.items).map(item => (
                                    <li key={item.id} className="product-enquiry__item">
                                        <div className="product-enquiry__header">
                                            {item.image
                                                ? <img
                                                    className="product-enquiry__image"
                                                    src={item.image}
                                                    width="210"
                                                    height="210"
                                                    alt={item.title}
                                                />
                                                : null}
                                            <h4 className="product-enquiry__title">
                                                {item.title}
                                                <span>{item.code}</span>
                                            </h4>
                                        </div>
                                        <p className="product-enquiry__desc">{item.description}</p>
                                        <div className="product-enquiry__btn-group">
                                            {item.pdf
                                            ? <a
                                                href={`${window.location.origin}/products/pdf/${item.id}`}
                                                className="product-enquiry__btn btn btn--tooltip gtm-product-download"
                                                target="_blank"
                                                data-product-name={item.title}
                                                data-product-code={item.code}
                                            >
                                                <svg><use xlinkHref="#datasheet-icon" /></svg>
                                                <div className="btn__tooltip">
                                                    Download specific datasheet PDF
                                                </div>
                                            </a>
                                            : <a className="product-enquiry__btn product-enquiry__btn--placeholder">
                                                <svg><use xlinkHref="#datasheet-icon" /></svg>
                                            </a>}
                                            <a onClick={() => { this.removeProduct(item.id) }} className="product-enquiry__btn btn btn--tooltip" target="_blank">
                                                <svg><use xlinkHref="#remove-icon" /></svg>
                                                <div className="btn__tooltip">
                                                    Remove product
                                                </div>
                                            </a>
                                            <div className="product-enquiry__counter">
                                                <Input count={item.count} id={item.id} />
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                            <a className="product-enquiry__btn product-enquiry__btn--full" href={`${window.location.origin}/products`}>
                                <svg><use xlinkHref="#plus-icon" /></svg>
                                <div>
                                    Add more products to my enquiry
                                </div>
                            </a>
                        </div>
                        <Wrapper items={this.productCodes(this.state.items)} />
                    </div>

                ) : (
                    <div>
                        <div className="product-enquiry__container">
                            <p>No products selected.</p>
                            <a className="product-enquiry__btn product-enquiry__btn--full" href={`${window.location.origin}/products`}>
                                <svg><use xlinkHref="#plus-icon" /></svg>
                                <div>
                                    Add more products to my enquiry
                                </div>
                            </a>
                        </div>
                        <Wrapper items="" />
                    </div>
                )
            }

            </div>
		)
	}
}
const container = document.getElementById("multiple-product-enquiry");
if (container) {
  const root = createRoot(container);
  root.render(<Enquiry />);
}